import React from 'react';
import { Code } from 'lucide-react';

type IconProps = React.HTMLAttributes<SVGElement>;

export const Icons = {
  // Usage example: <Icons.ArrowLeft />
  Code: Code,
  Add: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="Add"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <g
          id="Group"
          transform="translate(6, 6)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line
            x1="6"
            y1="0"
            x2="6"
            y2="12"
            id="Path"
          ></line>
          <line
            x1="12"
            y1="6"
            x2="0"
            y2="6"
            id="Path"
          ></line>
        </g>
      </g>
    </svg>
  ),
  ChevronClosed: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-chevron-closed</title>
      <g
        id="icon-chevron-closed"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          opacity="0.2"
          transform="translate(12, 12) rotate(90) translate(-12, -12)"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <polyline
          id="Path-2"
          stroke="currentColor"
          transform="translate(12.0902, 12.0451) rotate(90) translate(-12.0902, -12.0451)"
          points="8 10 12.090229 14.090229 16.1804581 10"
        ></polyline>
      </g>
    </svg>
  ),
  ChevronOpen: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-chevron-open</title>
      <g
        id="icon-chevron-open"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          opacity="0.199999988"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <polyline
          id="Path-2"
          stroke="currentColor"
          points="8 10 12.090229 14.090229 16.1804581 10"
        ></polyline>
      </g>
    </svg>
  ),
  ColorChange: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="ColorChange"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <g
          id="Group-4"
          transform="translate(4, 5)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M11.9830989,1.93861826 C10.5789104,0.665654409 8.7439168,-0.0269214719 6.84881419,0.000801239617 C3.06621664,0.000801239617 0,2.55531723 0,5.70792489 C0.13353775,8.17267636 1.81407658,10.2821527 4.18664171,10.963157 C5.1582084,11.3047338 5.96098033,11.0256244 6.52318651,9.75767005 C6.72995019,9.15827585 7.22615951,8.70434675 7.84154981,8.55163978 C8.45694011,8.39893281 9.10779864,8.568221 9.57079585,9.00141636 L9.70370511,9.13432562"
            id="Path"
          ></path>
          <line
            x1="13.2723188"
            y1="6.75657895"
            x2="9.69838874"
            y2="13.9017808"
            id="Path"
          ></line>
          <path
            d="M12.5054323,4.46389421 C12.1415749,5.29815229 12.4941364,6.27127189 13.3079188,6.67887077 C14.1217013,7.08646964 15.1121527,6.7860243 15.5623453,5.99500889 C16.4969889,4.55848545 16.3097611,2.6657723 15.1117829,1.44020853 C15.0640204,1.39470251 14.9942555,1.38091172 14.9327711,1.40482233 C14.8712867,1.42873293 14.8291685,1.48603381 14.8246989,1.55185231 C14.8366608,3.08695427 13.4517463,2.56727906 12.5054323,4.46389421 Z"
            id="Path"
          ></path>
          <path
            d="M3.52608268,6.59044238 C3.70959208,6.59044238 3.85835583,6.73920613 3.85835583,6.92271553"
            id="Path"
          ></path>
          <path
            d="M3.19380953,6.92404462 C3.19345611,6.83569024 3.22830728,6.75083342 3.29065893,6.68823236 C3.35301058,6.62563131 3.4377276,6.59044167 3.52608268,6.59044238"
            id="Path"
          ></path>
          <path
            d="M3.52608268,7.25498868 C3.34257329,7.25498868 3.19380953,7.10622492 3.19380953,6.92271553"
            id="Path"
          ></path>
          <path
            d="M3.85835583,6.92404462 C3.85762387,7.10703476 3.70907428,7.25499014 3.52608268,7.25498868"
            id="Path"
          ></path>
          <path
            d="M4.52290214,3.26771086 C4.70641153,3.26771086 4.85517529,3.41647462 4.85517529,3.59998401"
            id="Path"
          ></path>
          <path
            d="M4.19062898,3.60131311 C4.19062898,3.41780371 4.33939274,3.26903996 4.52290214,3.26903996"
            id="Path"
          ></path>
          <path
            d="M4.52290214,3.93225717 C4.33939274,3.93225717 4.19062898,3.78349341 4.19062898,3.59998401"
            id="Path"
          ></path>
          <path
            d="M4.85517529,3.60131311 C4.85444332,3.78430325 4.70589374,3.93225863 4.52290214,3.93225717"
            id="Path"
          ></path>
          <path
            d="M7.84563365,2.60316456 C8.02914304,2.60316456 8.1779068,2.75192832 8.1779068,2.93543771"
            id="Path"
          ></path>
          <path
            d="M7.5133605,2.9367668 C7.51300708,2.84841243 7.54785824,2.76355561 7.61020989,2.70095455 C7.67256154,2.63835349 7.75727857,2.60316385 7.84563365,2.60316456"
            id="Path"
          ></path>
          <path
            d="M7.84563365,3.26771086 C7.66212425,3.26771086 7.5133605,3.11894711 7.5133605,2.93543771"
            id="Path"
          ></path>
          <path
            d="M8.1779068,2.9367668 C8.1779068,3.1202762 8.02914304,3.26903996 7.84563365,3.26903996"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  ),
  Controls: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="Controls"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle
          id="Oval"
          stroke="currentColor"
          cx="9"
          cy="3.34782609"
          r="1.73913043"
        ></circle>
        <line
          x1="10.7373913"
          y1="3.34782609"
          x2="16.4095652"
          y2="3.34782609"
          id="Path"
          stroke="currentColor"
        ></line>
        <line
          x1="1.62695652"
          y1="3.34782609"
          x2="7.2573913"
          y2="3.34782609"
          id="Path"
          stroke="currentColor"
        ></line>
        <g
          id="Group-26"
          transform="translate(9.0183, 9) scale(-1, 1) translate(-9.0183, -9)translate(1.627, 7.2609)"
          stroke="currentColor"
        >
          <circle
            id="Oval"
            transform="translate(3.8948, 1.7391) scale(-1, 1) translate(-3.8948, -1.7391)"
            cx="3.89478261"
            cy="1.73913043"
            r="1.73913043"
          ></circle>
          <line
            x1="5.63043478"
            y1="1.73913043"
            x2="14.7826087"
            y2="1.73913043"
            id="Path"
            transform="translate(10.2065, 1.7391) scale(-1, 1) translate(-10.2065, -1.7391)"
          ></line>
          <line
            x1="0"
            y1="1.73913043"
            x2="2.15217391"
            y2="1.73913043"
            id="Path"
            transform="translate(1.0761, 1.7391) scale(-1, 1) translate(-1.0761, -1.7391)"
          ></line>
        </g>
        <circle
          id="Oval"
          stroke="currentColor"
          cx="7.26086957"
          cy="14.6521739"
          r="1.73913043"
        ></circle>
        <line
          x1="8.99652174"
          y1="14.6521739"
          x2="16.4095652"
          y2="14.6521739"
          id="Path"
          stroke="currentColor"
        ></line>
        <line
          x1="1.62695652"
          y1="14.6521739"
          x2="5.52173913"
          y2="14.6521739"
          id="Path"
          stroke="currentColor"
        ></line>
      </g>
    </svg>
  ),
  Delete: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="Delete"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <circle
          id="Oval"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="12"
          cy="12"
          r="7"
        ></circle>
        <line
          x1="8.95652174"
          y1="8.95652174"
          x2="15.0434783"
          y2="15.0434783"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <line
          x1="15.0434783"
          y1="8.95652174"
          x2="8.95652174"
          y2="15.0434783"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  ),
  Download: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-download</title>
      <g
        id="icon-download"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <circle
          id="Oval"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="12"
          cy="12"
          r="9"
        ></circle>
        <line
          x1="12"
          y1="7.5"
          x2="12"
          y2="16.5"
          id="Path"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <line
          x1="12"
          y1="16.5"
          x2="8.625"
          y2="13.125"
          id="Path"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <line
          x1="12"
          y1="16.5"
          x2="15.375"
          y2="13.125"
          id="Path"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  ),
  Export: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="Export"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <line
          x1="12"
          y1="13.125"
          x2="12"
          y2="5"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
        <polyline
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="9.1875 7.8125 12 5 14.8125 7.8125"
        ></polyline>
        <path
          d="M13.875,10.000625 L16.375,10.000625 C16.720178,10.000625 17,10.280447 17,10.625625 L17,18.750625 C17,19.095803 16.720178,19.375625 16.375,19.375625 L7.625,19.375625 C7.27982203,19.375625 7,19.095803 7,18.750625 L7,10.625625 C7,10.280447 7.27982203,10.000625 7.625,10.000625 L10.125,10.000625"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  ),
  Hide: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="hide"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <circle
          id="Oval"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="12.4986195"
          cy="11.8041442"
          r="2.58684689"
        ></circle>
        <path
          d="M20.906611,11.5617197 C20.0470387,10.5861089 16.6094888,7 12.4986195,7 C8.38775024,7 4.95020027,10.5861089 4.090628,11.5617197 C3.96979067,11.7007491 3.96979067,11.9075393 4.090628,12.0465687 C4.95020027,13.0221796 8.38775024,16.6082885 12.4986195,16.6082885 C16.6094888,16.6082885 20.0470387,13.0221796 20.906611,12.0465687 C21.0274483,11.9075393 21.0274483,11.7007491 20.906611,11.5617197 Z"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  ),
  Info: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="icon-download"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <circle
          id="Oval"
          fillRule="nonzero"
          cx="12.192"
          cy="12.192"
          r="8.192"
        ></circle>
        <path
          d="M12.192,4.00160754 C7.66678807,4.00160754 4,7.6683956 4,12.1928038 C4,16.7172119 7.66759184,20.3848038 12.192,20.3848038 C16.7172119,20.3848038 20.384,16.7172119 20.384,12.1928038 C20.384,7.6683956 16.7172119,4.00080377 12.192,4.00080377 L12.192,4.00160754 Z M12.192,4.8053752 C16.2727284,4.8053752 19.5802323,8.11287912 19.5802323,12.1936075 C19.5802323,16.2735322 16.2727284,19.5818399 12.192,19.5818399 C8.11127159,19.5818399 4.80376766,16.2735322 4.80376766,12.1936075 C4.80376766,8.11287912 8.11127159,4.80457143 12.192,4.80457143 L12.192,4.8053752 Z"
          id="Shape"
          fill="currentColor"
          fillRule="nonzero"
        ></path>
        <path
          d="M11.5425557,10.4920314 C12.0867064,10.4920314 12.534405,10.905168 12.5882575,11.4356546 L12.5938838,11.5425557 L12.5938838,16.0870581 C12.5938838,16.308898 12.4138399,16.4889419 12.192,16.4889419 C11.9950769,16.4889419 11.8303046,16.346675 11.7965463,16.1593972 L11.7901162,16.0870581 L11.7901162,11.5425557 C11.7901162,11.4260094 11.7089356,11.3279498 11.5996232,11.3014254 L11.5433595,11.2957991 L10.2436672,11.2957991 C10.0218273,11.2957991 9.84178336,11.1157551 9.84178336,10.8939152 C9.84178336,10.6961884 9.98405024,10.5322198 10.1713281,10.4984615 L10.2436672,10.4920314 L11.541752,10.4920314 L11.5425557,10.4920314 Z M11.2178336,7.24561381 L11.3094631,7.25124019 C11.6679435,7.29625118 11.9444396,7.60168289 11.9444396,7.97221978 C11.9444396,8.37410361 11.6197174,8.69882575 11.2178336,8.69882575 C10.8167535,8.69882575 10.4920314,8.37329984 10.4920314,7.97221978 C10.4920314,7.60248666 10.7685275,7.29625118 11.1270078,7.25124019 L11.2178336,7.24561381 Z"
          id="Shape"
          fill="currentColor"
          fillRule="nonzero"
        ></path>
        <path
          d="M14.139529,15.6867818 C14.3613689,15.6867818 14.5414129,15.8668257 14.5414129,16.0886656 C14.5414129,16.2855887 14.399146,16.4503611 14.2118681,16.4841193 L14.139529,16.4905495 L10.244471,16.4905495 C10.0226311,16.4905495 9.84258713,16.3105055 9.84258713,16.0886656 C9.84258713,15.8909388 9.984854,15.7269702 10.1721319,15.6932119 L10.244471,15.6867818 L14.139529,15.6867818 L14.139529,15.6867818 Z"
          id="Path"
          fill="currentColor"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  ),
  Lock: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="Lock"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <path
          d="M16,10.6666667 L16,8 C16,5.79133333 14.2086667,4 12,4 C9.79133333,4 8,5.79133333 8,8 L8,10.6666667 L7.5,10.6666667 C6.67157288,10.6666667 6,11.3382395 6,12.1666667 L6,18.5 C6,19.3284271 6.67157288,20 7.5,20 L16.5,20 C17.3284271,20 18,19.3284271 18,18.5 L18,12.1666667 C18,11.3382395 17.3284271,10.6666667 16.5,10.6666667 L16,10.6666667 L16,10.6666667 Z M9.33333333,10.6666667 L9.33333333,8 C9.33333333,6.52933333 10.5293333,5.33333333 12,5.33333333 C13.4706667,5.33333333 14.6666667,6.52933333 14.6666667,8 L14.6666667,10.6666667 L9.33333333,10.6666667 Z"
          id="Shape"
          fill="currentColor"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  ),
  ListView: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-list-view</title>
      <g
        id="icon-list-view"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <line
          x1="10.5"
          y1="8"
          x2="18.5"
          y2="8"
          id="Line-2"
          stroke="currentColor"
          strokeLinecap="round"
        ></line>
        <line
          x1="10.5"
          y1="12"
          x2="18.5"
          y2="12"
          id="Line-2"
          stroke="currentColor"
          strokeLinecap="round"
        ></line>
        <line
          x1="10.5"
          y1="16"
          x2="18.5"
          y2="16"
          id="Line-2"
          stroke="currentColor"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          fill="currentColor"
          cx="7"
          cy="8"
          r="1"
        ></circle>
        <circle
          id="Oval"
          fill="currentColor"
          cx="7"
          cy="12"
          r="1"
        ></circle>
        <circle
          id="Oval"
          fill="currentColor"
          cx="7"
          cy="16"
          r="1"
        ></circle>
      </g>
    </svg>
  ),
  More: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-more</title>
      <g
        id="icon-more"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <circle
          id="Oval"
          fill="currentColor"
          cx="6"
          cy="12"
          r="2"
        ></circle>
        <circle
          id="Oval"
          fill="currentColor"
          cx="12"
          cy="12"
          r="2"
        ></circle>
        <circle
          id="Oval"
          fill="currentColor"
          cx="18"
          cy="12"
          r="2"
        ></circle>
      </g>
    </svg>
  ),
  DisplayFillAndOutline: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="view-outline-fill"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-13">
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="18"
            height="18"
          ></rect>
          <rect
            id="Rectangle"
            stroke="currentColor"
            x="1.5"
            y="1.5"
            width="15"
            height="15"
            rx="1"
          ></rect>
          <rect
            id="Rectangle"
            fill="currentColor"
            x="3.5"
            y="3.5"
            width="11"
            height="11"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  DisplayOutlineOnly: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="view-outline"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-13">
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="18"
            height="18"
          ></rect>
          <rect
            id="Rectangle"
            stroke="currentColor"
            x="1.5"
            y="1.5"
            width="15"
            height="15"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  DisplayFillOnly: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="view-fill"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-13">
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="18"
            height="18"
          ></rect>
          <rect
            id="Rectangle"
            fill="currentColor"
            x="2"
            y="2"
            width="14"
            height="14"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  Actions: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="more-dropdown"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <g
          id="Group-2"
          transform="translate(5, 4)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle
            id="Oval"
            cx="6.74621802"
            cy="7.5938001"
            r="1.68710308"
          ></circle>
          <path
            d="M8.17972732,1.06493425 L8.67634848,2.69920529 C8.84616867,3.26259112 9.42371506,3.59782471 9.99714943,3.46585687 L11.6537273,3.08194406 C12.2982043,2.9366791 12.9621245,3.22831522 13.2911435,3.80120174 C13.6201625,4.37408825 13.5374848,5.09450899 13.0872366,5.57796434 L11.9284539,6.82714853 C11.528377,7.25995707 11.528377,7.92764314 11.9284539,8.36045168 L13.0872366,9.60963586 C13.5374848,10.0930912 13.6201625,10.813512 13.2911435,11.3863985 C12.9621245,11.959285 12.2982043,12.2509211 11.6537273,12.1056561 L9.99714943,11.7217433 C9.42371506,11.5897755 8.84616867,11.9250091 8.67634848,12.4883949 L8.17972732,14.122666 C7.98874475,14.7549849 7.40616232,15.1876002 6.745631,15.1876002 C6.08509968,15.1876002 5.50251725,14.7549849 5.31153468,14.122666 L4.81491352,12.4883949 C4.64509333,11.9250091 4.06754694,11.5897755 3.49411257,11.7217433 L1.83753467,12.1056561 C1.19305769,12.2509211 0.529137506,11.959285 0.200118485,11.3863985 C-0.128900535,10.813512 -0.0462227777,10.0930912 0.404025372,9.60963586 L1.56280807,8.36045168 C1.96288499,7.92764314 1.96288499,7.25995707 1.56280807,6.82714853 L0.404025372,5.57796434 C-0.0462227777,5.09450899 -0.128900535,4.37408825 0.200118485,3.80120174 C0.529137506,3.22831522 1.19305769,2.9366791 1.83753467,3.08194406 L3.49411257,3.46585687 C4.06754694,3.59782471 4.64509333,3.26259112 4.81491352,2.69920529 L5.31153468,1.06493425 C5.50251725,0.43261528 6.08509968,0 6.745631,0 C7.40616232,0 7.98874475,0.43261528 8.17972732,1.06493425 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  ),
  PinFill: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-pin-fill</title>
      <g
        id="icon-pin-fill"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <path
          d="M6.60822653,11.9185094 L12.4722476,17.7825305 C13.3039432,16.88156 13.5654769,15.59278 13.1507792,14.4388774 L17.647936,9.94247454 L17.7813806,10.0751652 C18.1510591,10.4324165 18.7388453,10.4274758 19.1024662,10.0640606 C19.4660871,9.70064533 19.4713604,9.11286206 19.1143182,8.74298142 L15.6462677,5.27493091 C15.2775626,4.90747491 14.6807861,4.90848754 14.3133301,5.27719268 C13.9458741,5.64589783 13.9468867,6.24267435 14.3155918,6.61013036 L14.4490364,6.74357491 L9.95187958,11.2407317 C8.7980766,10.8263652 7.50959437,11.087548 6.60822653,11.9185094 Z"
          id="Path"
          stroke="currentColor"
          fill="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <line
          x1="9.54023706"
          y1="14.8505199"
          x2="4.5"
          y2="19.890757"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  ),
  Pin: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-pin</title>
      <g
        id="icon-pin"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
          rx="4"
        ></rect>
        <path
          d="M6.60822653,11.9185094 L12.4722476,17.7825305 C13.3039432,16.88156 13.5654769,15.59278 13.1507792,14.4388774 L17.647936,9.94247454 L17.7813806,10.0751652 C18.1510591,10.4324165 18.7388453,10.4274758 19.1024662,10.0640606 C19.4660871,9.70064533 19.4713604,9.11286206 19.1143182,8.74298142 L15.6462677,5.27493091 C15.2775626,4.90747491 14.6807861,4.90848754 14.3133301,5.27719268 C13.9458741,5.64589783 13.9468867,6.24267435 14.3155918,6.61013036 L14.4490364,6.74357491 L9.95187958,11.2407317 C8.7980766,10.8263652 7.50959437,11.087548 6.60822653,11.9185094 Z"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <line
          x1="9.54023706"
          y1="14.8505199"
          x2="4.5"
          y2="19.890757"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  ),
  Rename: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="Rename"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <g
          id="rename"
          transform="translate(4.5, 5)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon
            id="Rectangle"
            transform="translate(7.6682, 7.2953) rotate(45) translate(-7.6682, -7.2953)"
            points="5.71337096 0.360798742 9.62306412 0.360798742 9.62306412 14.2297836 5.71337096 14.2297836"
          ></polygon>
          <polygon
            id="Path"
            points="1.38207653 10.8162548 0 14.963136 4.14688121 13.5810595"
          ></polygon>
          <path
            d="M13.9536949,3.77359418 L11.1895418,1.00944111 L11.650234,0.548748934 C12.4172745,-0.192083594 13.6365239,-0.181488647 14.3905743,0.57256175 C15.1446246,1.32661215 15.1552196,2.54586147 14.4143871,3.312902 L13.9536949,3.77359418 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  ),
  ThumbnailView: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-thumbnail-view</title>
      <g
        id="icon-thumbnail-view"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <rect
          id="Rectangle"
          fill="currentColor"
          x="6"
          y="6"
          width="5"
          height="5"
          rx="1.5"
        ></rect>
        <rect
          id="Rectangle"
          fill="currentColor"
          x="13"
          y="6"
          width="5"
          height="5"
          rx="1.5"
        ></rect>
        <rect
          id="Rectangle"
          fill="currentColor"
          x="6"
          y="13"
          width="5"
          height="5"
          rx="1.5"
        ></rect>
        <rect
          id="Rectangle"
          fill="currentColor"
          x="13"
          y="13"
          width="5"
          height="5"
          rx="1.5"
        ></rect>
      </g>
    </svg>
  ),
  IconMPR: (props: IconProps) => (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>info-mpr</title>
      <g
        id="info-mpr"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="12"
          height="12"
        ></rect>
        <g
          id="mpr"
          transform="translate(1.5, 1.5)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon
            id="Path"
            points="4.5 0 0 1.90909091 4.5 3.81818182 9 1.90909091"
          ></polygon>
          <polyline
            id="Path"
            points="0 1.90909091 0 7.09090909 4.5 9 9 7.09090909 9 1.90909091"
          ></polyline>
          <line
            x1="4.5"
            y1="3.81818182"
            x2="4.5"
            y2="9"
            id="Path"
          ></line>
        </g>
      </g>
    </svg>
  ),
  InfoSeries: (props: IconProps) => (
    <svg
      width="12px"
      height="12px"
      viewBox="0 0 12 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>info-series</title>
      <g
        id="info-series"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="12"
          height="12"
        ></rect>
        <g
          id="series"
          transform="translate(1.5, 1.5)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M2.22352941,6.3 L0.370588235,6.3 C0.165918004,6.3 0,6.134082 0,5.92941176 L0,0.370588235 C0,0.165918004 0.165918004,0 0.370588235,0 L5.92941176,0 C6.134082,0 6.3,0.165918004 6.3,0.370588235 L6.3,2.22352941"
            id="Path"
          ></path>
          <rect
            id="Rectangle"
            x="2.7"
            y="2.7"
            width="6.3"
            height="6.3"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  StatusError: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
    >
      <g
        id="StatusAlert"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <circle
          id="Oval"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="12"
          cy="12"
          r="8"
        ></circle>
        <g
          id="Group"
          transform="translate(11.5, 8)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line
            x1="0.502969489"
            y1="5"
            x2="0.502969489"
            y2="5.55111512e-16"
            id="Path"
          ></line>
          <path
            d="M0.494019489,7.75 C0.427967985,7.75102315 0.365128544,7.77867594 0.319754003,7.82668634 C0.274379462,7.87469675 0.250315262,7.93899595 0.253019489,8.005 C0.257853669,8.14136674 0.369567839,8.24954844 0.506019489,8.25 L0.506019489,8.25 C0.57198073,8.2487037 0.634656968,8.22096694 0.679972815,8.17301863 C0.725288662,8.12507033 0.749445908,8.06092934 0.747019489,7.995 C0.742888429,7.86182395 0.636177529,7.75467571 0.503019489,7.75 L0.498019489,7.75"
            id="Path"
          ></path>
        </g>
      </g>
    </svg>
  ),
  StatusSuccess: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="StatusSuccess"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <polyline
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="16.173913 8.52173913 11.3043478 15.1304348 7.82608696 12.3478261"
        ></polyline>
        <circle
          id="Oval"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="12"
          cy="12"
          r="8"
        ></circle>
      </g>
    </svg>
  ),
  StatusTracking: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>status-tracking</title>
      <g
        id="status-tracking"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g>
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <rect
            id="Rectangle"
            stroke="#5ACCE6"
            fill="#5ACCE6"
            x="4.5"
            y="4.5"
            width="15"
            height="15"
            rx="7.5"
          ></rect>
          <path
            d="M15.388889,9 L11.7739644,14.5948033 C11.6112717,14.8456871 11.3630166,15.0025668 11.0931982,15.0249993 C10.8233798,15.0474318 10.5584004,14.9332222 10.3665704,14.7118131 L8.5,12.5449644"
            id="Path"
            stroke="#090C29"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </g>
      </g>
    </svg>
  ),
  StatusWarning: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>status-warning</title>
      <g
        id="status-warning"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g>
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <g
            id="Group-5"
            transform="translate(4, 4)"
            stroke="#FFD22A"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path
              d="M8.0001715,11.3365862 C8.1842651,11.3365862 8.33350959,11.4858235 8.33350959,11.6699171 C8.33350959,11.8540107 8.1842651,12.0032552 8.0001715,12.0032552 C7.8160779,12.0032552 7.66684054,11.8540107 7.66684054,11.6699171 C7.66684054,11.4858235 7.8160779,11.3365862 8.0001715,11.3365862"
              id="Path"
            ></path>
            <line
              x1="8.0001715"
              y1="8.67127184"
              x2="8.0001715"
              y2="4.67130038"
              id="Path"
            ></line>
            <path
              d="M9.11749686,0.669995592 C8.89725509,0.25756493 8.46772416,0 8.0001715,0 C7.53261884,0 7.10308791,0.25756493 6.88284614,0.669995592 L0.141560901,13.5152373 C-0.0609866009,13.9006851 -0.0452769444,14.3643734 0.18289394,14.7352286 C0.413865574,15.107289 0.820963502,15.3332864 1.25888626,15.3325594 L14.7414567,15.3325594 C15.1793795,15.3332864 15.5864774,15.107289 15.8174491,14.7352286 C16.0456199,14.3643734 16.0613296,13.9006851 15.8587821,13.5152373 L9.11749686,0.669995592 Z"
              id="Path"
              fillOpacity="0.2"
              fill="#FFD22A"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  SortingAscending: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="16"
      viewBox="0 0 9 16"
      {...props}
    >
      <g
        fill="currentColor"
        fillRule="evenodd"
      >
        <path
          fill="transparent"
          d="M8.69 11.516L7.51 10.274 4.5 13.442 1.49 10.274 0.31 11.516 4.5 15.926z"
        />
        <path
          d="M8.69 1.516L7.51 0.274 4.499 3.442 1.49 0.274 0.31 1.516 4.5 5.926z"
          transform="matrix(1 0 0 -1 0 6.2)"
        />
      </g>
    </svg>
  ),
  SortingDescending: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="16"
      viewBox="0 0 9 16"
      {...props}
    >
      <g
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="M8.69 11.516L7.51 10.274 4.5 13.442 1.49 10.274 0.31 11.516 4.5 15.926z" />
        <path
          fill="transparent"
          d="M8.69 1.516L7.51 0.274 4.499 3.442 1.49 0.274 0.31 1.516 4.5 5.926z"
          transform="matrix(1 0 0 -1 0 6.2)"
        />
      </g>
    </svg>
  ),
  Trash: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      aria-labelledby="title"
      fill="currentColor"
      {...props}
    >
      <title id="title">Trash</title>
      <path d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z" />
    </svg>
  ),
  Cancel: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      {...props}
    >
      <g
        fill="currentColor"
        fillRule="evenodd"
      >
        <circle
          cx="9.5"
          cy="9.5"
          r="9.5"
          fill="currentColor"
        />
        <g
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        >
          <path
            d="M.188.187L8.813 8.812M8.813.187L.188 8.812"
            transform="translate(5 5)"
          />
        </g>
      </g>
    </svg>
  ),
  InfoLink: (props: IconProps) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="currentColor"
        fillRule="evenodd"
      >
        <path d="M7 .102A6.899 6.899 0 1 0 7 13.9 6.899 6.899 0 0 0 7 .102zm0 .875a6.024 6.024 0 1 1 0 12.048A6.024 6.024 0 0 1 7 .977z" />
        <path d="M6.462 5.486c.503 0 .917.38.97.87l.006.106v3.769a.438.438 0 0 1-.868.078l-.007-.078V6.46a.101.101 0 0 0-.07-.095l-.031-.005H5.385a.437.437 0 0 1-.079-.868l.079-.007h1.077zM6.192 2.793l.089.006a.707.707 0 1 1-.177 0l.088-.006z" />
        <path d="M8.615 9.794c.242 0 .438.224.438.5 0 .246-.155.45-.359.492l-.079.008h-3.23c-.242 0-.438-.224-.438-.5 0-.245.155-.45.359-.492l.079-.008h3.23z" />
      </g>
    </svg>
  ),
  LoadingSpinner: (props: IconProps) => (
    <svg
      role="status"
      aria-label="Loading"
      className={`h-5 w-5 animate-spin ${props.className}`}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="LoadingSpinner"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <g
          id="Group"
          transform="translate(1, 1)"
          fillRule="nonzero"
        >
          <path
            d="M11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 Z M11,2 C6.02943725,2 2,6.02943725 2,11 C2,15.9705627 6.02943725,20 11,20 C15.9705627,20 20,15.9705627 20,11 C20,6.02943725 15.9705627,2 11,2 Z"
            id="Oval"
            fill="#348CFD"
            opacity="0.25"
          ></path>
          <path
            d="M19.0287175,4.94590384 C19.5005019,4.65878387 20.1157155,4.80848402 20.4028355,5.28026847 C21.4419642,6.98772474 22,8.94986784 22,10.9915479 C22,17.0666801 17.0751322,21.9915479 11,21.9915479 C10.4477153,21.9915479 10,21.5438326 10,20.9915479 C10,20.4392631 10.4477153,19.9915479 11,19.9915479 C15.9705627,19.9915479 20,15.9621106 20,10.9915479 C20,9.31924154 19.5441371,7.7163545 18.6943528,6.32002184 C18.4072329,5.84823739 18.556933,5.2330238 19.0287175,4.94590384 Z"
            id="Oval"
            fill="#5ACCE6"
          ></path>
        </g>
      </g>
    </svg>
  ),
  NavigationPanelReveal: (props: IconProps) => (
    <svg
      width="17"
      height="10"
      viewBox="0 0 17 10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.856 5.078H1M5.078 1 1 5.078l4.078 4.078M15.582 9.156V1" />
      </g>
    </svg>
  ),
  MissingIcon: (props: IconProps) => <div>Missing icon</div>,
  Series: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="Series"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <path
          d="M8.17391304,15.826087 L4.69565217,15.826087 C4.31145409,15.826087 4,15.5146329 4,15.1304348 L4,4.69565217 C4,4.31145409 4.31145409,4 4.69565217,4 L15.1304348,4 C15.5146329,4 15.826087,4.31145409 15.826087,4.69565217 L15.826087,8.17391304"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <rect
          id="Rectangle"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="8.17391304"
          y="8.17391304"
          width="11.826087"
          height="11.826087"
          rx="1"
        ></rect>
      </g>
    </svg>
  ),
  Settings: (props: IconProps) => (
    <svg
      width="15.7826087px"
      height="15.7826087px"
      viewBox="0 0 15.7826087 15.7826087"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-display-settings</title>
      <g
        id="Artboards"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Segmentation---assets"
          transform="translate(-42.127, -62.1087)"
          stroke="currentColor"
        >
          <g
            id="icon-display-settings"
            transform="translate(40, 60)"
          >
            <circle
              id="Oval"
              cx="10"
              cy="4.34782609"
              r="1.73913043"
            ></circle>
            <line
              x1="11.7373913"
              y1="4.34782609"
              x2="17.4095652"
              y2="4.34782609"
              id="Path"
            ></line>
            <line
              x1="2.62695652"
              y1="4.34782609"
              x2="8.2573913"
              y2="4.34782609"
              id="Path"
            ></line>
            <g
              id="Group-26"
              transform="translate(10.0183, 10) scale(-1, 1) translate(-10.0183, -10)translate(2.627, 8.2609)"
            >
              <circle
                id="Oval"
                transform="translate(3.8948, 1.7391) scale(-1, 1) translate(-3.8948, -1.7391)"
                cx="3.89478261"
                cy="1.73913043"
                r="1.73913043"
              ></circle>
              <line
                x1="5.63043478"
                y1="1.73913043"
                x2="14.7826087"
                y2="1.73913043"
                id="Path"
                transform="translate(10.2065, 1.7391) scale(-1, 1) translate(-10.2065, -1.7391)"
              ></line>
              <line
                x1="0"
                y1="1.73913043"
                x2="2.15217391"
                y2="1.73913043"
                id="Path"
                transform="translate(1.0761, 1.7391) scale(-1, 1) translate(-1.0761, -1.7391)"
              ></line>
            </g>
            <circle
              id="Oval"
              cx="8.26086957"
              cy="15.6521739"
              r="1.73913043"
            ></circle>
            <line
              x1="9.99652174"
              y1="15.6521739"
              x2="17.4095652"
              y2="15.6521739"
              id="Path"
            ></line>
            <line
              x1="2.62695652"
              y1="15.6521739"
              x2="6.52173913"
              y2="15.6521739"
              id="Path"
            ></line>
          </g>
        </g>
      </g>
    </svg>
  ),
  Show: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        id="show"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <path
          d="M18.0567826,8.96286957 C19.1471229,9.75269568 20.1356859,10.674229 21,11.7065217 C21,11.7065217 17.1949565,16.5108696 12.5,16.5108696 C11.7479876,16.5066962 11.0007435,16.3911225 10.2826087,16.167913"
          id="Path"
          stroke="#348CFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M6.93286957,14.4413043 C5.84666081,13.6535964 4.86162018,12.7350857 4,11.7065217 C4,11.7065217 7.80504348,6.90217391 12.5,6.90217391 C13.1235541,6.90480509 13.7443251,6.98550531 14.3478261,7.1423913"
          id="Path"
          stroke="#348CFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M9.54347826,11.7065217 C9.54347826,10.0736799 10.8671581,8.75 12.5,8.75"
          id="Path"
          stroke="#348CFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M15.4565217,11.7065217 C15.4565217,13.3393636 14.1328419,14.6630435 12.5,14.6630435"
          id="Path"
          stroke="#348CFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <line
          x1="19.7065217"
          y1="4.5"
          x2="5.29347826"
          y2="18.9130435"
          id="Path"
          stroke="#348CFD"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  ),
  SidePanelCloseLeft: (props: IconProps) => (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-panel-close-left</title>
      <g
        id="Artboards-Updated"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Segmentation---assets"
          transform="translate(-370, -60)"
        >
          <g
            id="icon-panel-close-left"
            transform="translate(380, 70) scale(-1, 1) translate(-380, -70)translate(370, 60)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="20"
              height="20"
            ></rect>
            <line
              x1="12.8336364"
              y1="10.4061473"
              x2="3"
              y2="10.4061473"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(7.9168, 10.4061) scale(-1, 1) translate(-7.9168, -10.4061)"
            ></line>
            <polyline
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(10.7991, 10.4061) scale(-1, 1) translate(-10.7991, -10.4061)"
              points="12.8336364 6.33705636 8.76454545 10.4061473 12.8336364 14.4752382"
            ></polyline>
            <line
              x1="16.2418182"
              y1="14.4752382"
              x2="16.2418182"
              y2="6.33705636"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(16.2418, 10.4061) scale(-1, 1) translate(-16.2418, -10.4061)"
            ></line>
          </g>
        </g>
      </g>
    </svg>
  ),
  SidePanelCloseRight: (props: IconProps) => (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>icon-panel-close-right</title>
      <g
        id="Artboards-Updated"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Segmentation---assets"
          transform="translate(-418, -60)"
        >
          <g
            id="icon-panel-close-right"
            transform="translate(418, 60)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="20"
              height="20"
            ></rect>
            <line
              x1="12.8336364"
              y1="10.4061473"
              x2="3"
              y2="10.4061473"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(7.9168, 10.4061) scale(-1, 1) translate(-7.9168, -10.4061)"
            ></line>
            <polyline
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(10.7991, 10.4061) scale(-1, 1) translate(-10.7991, -10.4061)"
              points="12.8336364 6.33705636 8.76454545 10.4061473 12.8336364 14.4752382"
            ></polyline>
            <line
              x1="16.2418182"
              y1="14.4752382"
              x2="16.2418182"
              y2="6.33705636"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(16.2418, 10.4061) scale(-1, 1) translate(-16.2418, -10.4061)"
            ></line>
          </g>
        </g>
      </g>
    </svg>
  ),
  TabSegmentation: (props: IconProps) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <circle
          stroke="currentColor"
          cx="11.037"
          cy="10.912"
          r="8"
        />
        <g stroke="currentColor">
          <path
            strokeLinecap="square"
            d="m11.354 3.575-7.779 7.779M17.364 6.757 6.757 17.364"
          />
          <path d="m18.955 9.763-9.192 9.192" />
          <path
            strokeLinecap="square"
            d="M15.066 4.46 4.459 15.065"
          />
        </g>
        <path d="M0 0h22v22H0z" />
      </g>
    </svg>
  ),
  TabLinear: (props: IconProps) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <rect
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="1.5"
          y="16.37"
          width="4.13"
          height="4.13"
          rx="1"
        />
        <rect
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="16.37"
          y="1.5"
          width="4.13"
          height="4.13"
          rx="1"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.388 16.612 16.612 5.388"
        />
        <path d="M0 0h22v22H0z" />
      </g>
    </svg>
  ),
  TabStudies: (props: IconProps) => (
    <svg
      width="22px"
      height="23px"
      viewBox="0 0 22 23"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>tab-studies</title>
      <g
        id="Artboards-Updated"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Segmentation---assets"
          transform="translate(-61, -242)"
        >
          <g
            id="tab-studies"
            transform="translate(61, 242.5)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="22"
              height="22"
            ></rect>
            <path
              d="M6.93478261,15.0652174 L3.23913043,15.0652174 C2.83091997,15.0652174 2.5,14.7342974 2.5,14.326087 L2.5,3.23913043 C2.5,2.83091997 2.83091997,2.5 3.23913043,2.5 L14.326087,2.5 C14.7342974,2.5 15.0652174,2.83091997 15.0652174,3.23913043 L15.0652174,6.93478261"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <rect
              id="Rectangle"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
              x="6.93478261"
              y="6.93478261"
              width="12.5652174"
              height="12.5652174"
              rx="1"
            ></rect>
          </g>
        </g>
      </g>
    </svg>
  ),
  Refresh: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <path
          d="M4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <polyline
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="12 8 12 12 15 14"
        ></polyline>
      </g>
    </svg>
  ),
  Tab4D: (props: IconProps) => (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>tab-4d</title>
      <g
        id="tab-4d"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Group"
          transform="translate(1, 1)"
          stroke="currentColor"
        >
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="20"
            height="20"
            rx="2"
          ></rect>
          <g
            id="Group-3"
            transform="translate(4, 5)"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path
              d="M6.9072464,0.398231009 C9.3565092,0.398231009 11.342029,2.38375081 11.342029,4.83301362 C11.342029,7.28227642 9.3565092,9.26779623 6.9072464,9.26779623 L6.9072464,0.398231009 Z"
              id="Path"
            ></path>
            <polyline
              id="Path-2"
              points="3.27497101 4.83301362 0 4.83301362 3.62401581 0 3.62401581 4.87475204 3.62401581 9.26779623"
            ></polyline>
          </g>
        </g>
      </g>
    </svg>
  ),
  TabPatientInfo: (props: IconProps) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M3.638 13.16a17.265 17.265 0 0 1 3.652-1.586c.565-.21.626-1.504.221-1.95-.584-.642-1.08-1.396-1.08-3.215a2.572 2.572 0 0 1 2.632-2.811 2.572 2.572 0 0 1 2.631 2.811c0 1.822-.495 2.573-1.08 3.215-.404.446-.343 1.74.222 1.95 1.275.386 2.5.919 3.652 1.587"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.15 11.064V2.369a.87.87 0 0 0-.87-.869H2.37a.87.87 0 0 0-.87.87v13.91c0 .48.39.87.87.87h8.694M15.846 20.628l-3.043.87.87-3.044 5.2-5.2a1.537 1.537 0 0 1 2.174 2.173l-5.201 5.2zM18.221 13.905l2.174 2.174M13.672 18.454l2.174 2.174"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M0 0h22v22H0z" />
      </g>
    </svg>
  ),
  TabRoiThreshold: (props: IconProps) => (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="m13.34 11.74-2.971.425.425-2.971 7.64-7.64A1.8 1.8 0 1 1 20.98 4.1l-7.64 7.64zM8.644 19.034h7.383c.865 0 1.566-.701 1.566-1.566V10.03M12.504 4.94H5.066C4.2 4.94 3.5 5.643 3.5 6.508v1.972"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          stroke="currentColor"
          d="m11.5 8.5 2.333 2.333"
        />
        <g
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m1 14 2.5-2.5L6 14M1 17.5 3.5 20 6 17.5" />
        </g>
        <path d="M0 0h22v22H0z" />
      </g>
    </svg>
  ),
  Plus: (props: IconProps) => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <path d="M0 0h21v21H0z" />
        <g
          stroke="#348CFD"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        >
          <path d="M10.5 5.5v10M15.5 10.5h-10" />
        </g>
      </g>
    </svg>
  ),
  Minus: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Remove"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <line
          x1="18"
          y1="12"
          x2="6"
          y2="12"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></line>
      </g>
    </svg>
  ),

  FillAndOutline: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="view-outline-fill"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-13">
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="18"
            height="18"
          ></rect>
          <rect
            id="Rectangle"
            stroke="#348CFD"
            x="1.5"
            y="1.5"
            width="15"
            height="15"
            rx="1"
          ></rect>
          <rect
            id="Rectangle"
            fill="#348CFD"
            x="3.5"
            y="3.5"
            width="11"
            height="11"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  OutlineOnly: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="view-outline"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-13">
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="18"
            height="18"
          ></rect>
          <rect
            id="Rectangle"
            stroke="#348CFD"
            x="1.5"
            y="1.5"
            width="15"
            height="15"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  FillOnly: (props: IconProps) => (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      {...props}
    >
      <g
        id="view-fill"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-13">
          <rect
            id="Rectangle"
            x="0"
            y="0"
            width="18"
            height="18"
          ></rect>
          <rect
            id="Rectangle"
            fill="#348CFD"
            x="2"
            y="2"
            width="14"
            height="14"
            rx="1"
          ></rect>
        </g>
      </g>
    </svg>
  ),
  EyeVisible: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 13"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(0 1)"
      >
        <circle
          cx="10"
          cy="5.833"
          r="2.917"
        />
        <path d="M19.48 5.56C18.51 4.46 14.635.417 10 .417 5.365.417 1.49 4.46.52 5.56c-.136.157-.136.39 0 .547.97 1.1 4.845 5.143 9.48 5.143 4.635 0 8.51-4.043 9.48-5.143.136-.157.136-.39 0-.547z" />
      </g>
    </svg>
  ),
  EyeHidden: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 20"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <g opacity=".5">
          <path
            d="M17.433 2.556c1.352.98 2.578 2.122 3.65 3.402 0 0-4.719 5.959-10.541 5.959-.933-.006-1.86-.149-2.75-.426M3.637 9.35C2.29 8.373 1.07 7.234 0 5.958 0 5.958 4.719 0 10.542 0c.773.003 1.543.103 2.291.298M6.875 5.958c0-2.025 1.642-3.666 3.667-3.666M14.208 5.958c0 2.025-1.641 3.667-3.666 3.667"
            transform="translate(1 1) translate(.458 3.208)"
          />
        </g>
        <path
          d="M19.938 0.229L2.063 18.104"
          transform="translate(1 1)"
        />
      </g>
    </svg>
  ),
  ViewportViews: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="icon-views"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="24"
          height="24"
        ></rect>
        <path
          d="M12.1675111,14.754511 C12.0607016,14.815163 11.9392984,14.815163 11.8324889,14.754511 L3.25173267,9.89965265 C3.09886891,9.81313583 3,9.61689546 3,9.4 C3,9.18310454 3.09886891,8.98686417 3.25173267,8.90034735 L11.8324889,4.04548902 C11.9392984,3.98483699 12.0607016,3.98483699 12.1675111,4.04548902 L20.7482673,8.90034735 C20.9011311,8.98686417 21,9.18310454 21,9.4 C21,9.61689546 20.9011311,9.81313583 20.7482673,9.89965265 L12.1675111,14.754511 Z"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M16.7792809,12.1 L20.7482673,14.3367372 C20.9011311,14.4227204 21,14.6177503 21,14.833308 C21,15.0488656 20.9011311,15.2438955 20.7482673,15.3298787 L12.1675111,20.1547916 C12.0607016,20.2150695 11.9392984,20.2150695 11.8324889,20.1547916 L3.25173267,15.3298787 C3.09886891,15.2438955 3,15.0488656 3,14.833308 C3,14.6177503 3.09886891,14.4227204 3.25173267,14.3367372 L7.2018101,12.1"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  ),
  StatusChecked: (props: IconProps) => (
    <svg
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      {...props}
    >
      <g
        id="status-checked"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="14"
          height="14"
        ></rect>
        <circle
          id="Oval"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          cx="7"
          cy="7"
          r="6"
        ></circle>
        <path
          d="M9.674,5.256 L6.769,9.129 C6.63825806,9.30267425 6.43875708,9.41127411 6.22192754,9.42680302 C6.00509799,9.44233192 5.79215707,9.36327034 5.638,9.21 L4.138,7.71"
          id="Path"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  ),

  DicomTagBrowser: (props: IconProps) => (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>tool-dicom-tag-browser</title>
      <g
        id="tool-dicom-tag-browser"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="28"
          height="28"
        ></rect>
        <g
          id="Group"
          transform="translate(4, 5.5)"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        >
          <circle
            id="Oval"
            cx="1.73913043"
            cy="1.73913043"
            r="1.73913043"
          ></circle>
          <line
            x1="6.95652174"
            y1="1.73913043"
            x2="20"
            y2="1.73913043"
            id="Path"
          ></line>
          <circle
            id="Oval"
            cx="1.73913043"
            cy="8.69565217"
            r="1.73913043"
          ></circle>
          <line
            x1="6.95652174"
            y1="8.69565217"
            x2="20"
            y2="8.69565217"
            id="Path"
          ></line>
          <circle
            id="Oval"
            cx="1.73913043"
            cy="15.6521739"
            r="1.73913043"
          ></circle>
          <line
            x1="6.95652174"
            y1="15.6521739"
            x2="20"
            y2="15.6521739"
            id="Path"
          ></line>
        </g>
      </g>
    </svg>
  ),
  PowerOff: (props: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 28"
      aria-labelledby="title"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
    >
      <title id="title">Power Off</title>
      <path d="M24 14c0 6.609-5.391 12-12 12s-12-5.391-12-12c0-3.797 1.75-7.297 4.797-9.578 0.891-0.672 2.141-0.5 2.797 0.391 0.672 0.875 0.484 2.141-0.391 2.797-2.031 1.531-3.203 3.859-3.203 6.391 0 4.406 3.594 8 8 8s8-3.594 8-8c0-2.531-1.172-4.859-3.203-6.391-0.875-0.656-1.062-1.922-0.391-2.797 0.656-0.891 1.922-1.062 2.797-0.391 3.047 2.281 4.797 5.781 4.797 9.578zM14 2v10c0 1.094-0.906 2-2 2s-2-0.906-2-2v-10c0-1.094 0.906-2 2-2s2 0.906 2 2z" />
    </svg>
  ),
  MultiplePatients: (props: IconProps) => (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>icon-multiple-patients</title>
      <g
        id="4D-assets---final"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-171, -280)"
        >
          <g
            id="icon-multiple-patients"
            transform="translate(171, 280)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="28"
              height="28"
            ></rect>
            <g
              id="Group-3"
              transform="translate(2, 1.5)"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <g
                id="patient-icon"
                transform="translate(9, 10)"
              >
                <circle
                  id="Oval"
                  cx="7.5"
                  cy="7.5"
                  r="7.5"
                ></circle>
                <path
                  d="M2.331,12.935 C3.39163827,12.4490078 4.47638164,12.0174468 5.581,11.642 C6.189,11.416 6.09,9.827 5.82,9.531 C4.95198021,8.59033128 4.52668888,7.3239163 4.651,6.05 C4.5727272,5.23902161 4.83519788,4.43201369 5.37555564,3.82223826 C5.9159134,3.21246283 6.68549454,2.85483523 7.5,2.835 C8.31450546,2.85483523 9.0840866,3.21246283 9.62444436,3.82223826 C10.1648021,4.43201369 10.4272728,5.23902161 10.349,6.05 C10.4733111,7.3239163 10.0480198,8.59033128 9.18,9.531 C8.91,9.831 8.811,11.416 9.419,11.642 C10.5236184,12.0174468 11.6083617,12.4490078 12.669,12.935"
                  id="Path"
                ></path>
              </g>
              <g id="patient-icon">
                <path
                  d="M7.5,0 C11.6421356,0 15,3.35786438 15,7.5 C15,8.48189915 14.8113103,9.41972745 14.4682129,10.2792028 C12.213795,10.9117859 10.3898771,12.5712406 9.53178711,14.7207972 C8.88630634,14.9028658 8.20449663,15 7.5,15 C3.35786438,15 0,11.6421356 0,7.5 C0,3.35786438 3.35786438,0 7.5,0 Z"
                  id="Combined-Shape"
                ></path>
                <path
                  d="M2.331,12.935 C3.39163827,12.4490078 4.47638164,12.0174468 5.581,11.642 C6.189,11.416 6.09,9.827 5.82,9.531 C4.95198021,8.59033128 4.52668888,7.3239163 4.651,6.05 C4.5727272,5.23902161 4.83519788,4.43201369 5.37555564,3.82223826 C5.9159134,3.21246283 6.68549454,2.85483523 7.5,2.835 C8.31450546,2.85483523 9.0840866,3.21246283 9.62444436,3.82223826 C10.1648021,4.43201369 10.4272728,5.23902161 10.349,6.05 C10.4733111,7.3239163 10.0480198,8.59033128 9.18,9.531 C8.91,9.831 8.811,11.416 9.419,11.642 C10.5236184,12.0174468 10.5236184,12.0174468 10.9701462,12.2764988"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  Patient: (props: IconProps) => (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>icon-patient</title>
      <g
        id="Production"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-104, -235)"
        >
          <g
            id="icon-patient"
            transform="translate(104, 235)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="28"
              height="28"
            ></rect>
            <circle
              id="Oval"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              cx="14"
              cy="14"
              r="9"
            ></circle>
            <path
              d="M7.7972,20.522 C9.06996592,19.9388093 10.371658,19.4209361 11.6972,18.9704 C12.4268,18.6992 12.308,16.7924 11.984,16.4372 C10.9423763,15.3083975 10.4320267,13.7886996 10.5812,12.26 C10.4872726,11.2868259 10.8022375,10.3184164 11.4506668,9.58668591 C12.0990961,8.8549554 13.0225934,8.42580227 14,8.402 C14.9774066,8.42580227 15.9009039,8.8549554 16.5493332,9.58668591 C17.1977625,10.3184164 17.5127274,11.2868259 17.4188,12.26 C17.5679733,13.7886996 17.0576237,15.3083975 16.016,16.4372 C15.692,16.7972 15.5732,18.6992 16.3028,18.9704 C17.628342,19.4209361 18.9300341,19.9388093 20.2028,20.522"
              id="Path"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  ChevronPatient: (props: IconProps) => (
    <svg
      width="28px"
      height="29px"
      viewBox="0 0 28 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Production"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-154, -234)"
        >
          <g
            id="icon-chevron-patient"
            transform="translate(168, 248.5) scale(-1, -1) translate(-168, -248.5)translate(154, 234.5)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="28"
              height="28"
            ></rect>
            <polyline
              id="Path"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              transform="translate(14.5, 14) scale(-1, 1) translate(-14.5, -14)"
              points="16.5 10 12.5 14 16.5 18"
            ></polyline>
          </g>
        </g>
      </g>
    </svg>
  ),
  OHIFLogo: (props: IconProps) => (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="30"
    >
      <path
        d="M0 0 C3.07189591 2.62690164 5.45246697 5.20150985 7 9 C7.66 9 8.32 9 9 9 C12.83662346 16.08299715 15.55206829 23.54035556 18.30371094 31.09033203 C18.90823304 32.74831656 19.51988781 34.40369708 20.1328125 36.05859375 C21.85118709 40.71985395 23.46472855 45.40017235 25 50.125 C26.43819713 54.48453504 28.08475384 58.63781184 30.00390625 62.8046875 C31.82046881 66.8082489 33.4000932 70.90612083 35 75 C35.391875 76.0003125 35.78375 77.000625 36.1875 78.03125 C38.84809881 84.88229194 41.36765385 91.77173285 43.7890625 98.7109375 C44.61918387 100.96565427 45.5164855 103.19643316 46.46875 105.40234375 C48.12006938 109.28210179 49.50948544 113.20114457 50.875 117.1875 C53.32932183 124.24357983 56.04167344 131.13819463 59 138 C61.63711897 144.18197029 64.19785344 150.32289581 66.2578125 156.72265625 C68.24002254 162.80491127 70.4054384 168.80380398 73.0625 174.625 C74.33988621 177.42637207 75.4393354 180.19215657 76.375 183.125 C77.67497522 187.17951732 79.21368297 191.11851439 80.8125 195.0625 C83.24162334 201.05913771 85.55929478 207.0889037 87.81738281 213.15185547 C90.57327174 220.55085739 93.40343675 227.9209756 96.28125 235.2734375 C98.34980593 240.58357193 100.3174849 245.88659366 102.0625 251.3125 C103.41609789 255.47153868 105.02606628 259.2275514 107.06640625 263.0859375 C108.40605787 265.83250358 109.2968773 268.67458492 110.22265625 271.58203125 C112.19504895 277.71726281 114.38590985 283.76102006 117.0625 289.625 C118.66792688 293.14578173 119.91196607 296.67229466 121.0859375 300.35546875 C122.26536454 303.76774271 123.63400218 307.09696541 125 310.4375 C126.73353458 314.67917185 128.34189895 318.89043678 129.5625 323.3125 C130.79410997 327.7142303 132.69933695 331.52809498 134.80859375 335.5703125 C136.25958048 338.52937396 137.27242957 341.51351162 138.2578125 344.65234375 C140.40808395 351.45399186 142.90909761 358.09638553 145.97265625 364.5390625 C146.89571279 366.75018652 147.65382167 368.94188174 148.39453125 371.21875 C149.66580837 375.1031857 151.13695902 378.85913822 152.70361328 382.63232422 C157.68619064 394.76002842 159.63575371 404.28275994 155 417 C153.56728947 419.87494072 151.94019096 422.44422437 150 425 C149.39285156 425.82242187 148.78570312 426.64484375 148.16015625 427.4921875 C142.98309419 433.50244761 135.57793319 437.76494093 127.6953125 438.83984375 C115.26537626 439.57843416 105.72647215 436.51177823 94.35302734 431.9375 C90.73856291 430.49741457 87.08726938 429.15991064 83.4375 427.8125 C79.38330662 426.29817804 75.35136421 424.74697931 71.3359375 423.1328125 C65.31075522 420.71255747 59.25008615 418.38714401 53.1875 416.0625 C50.99348958 415.22005208 48.79947917 414.37760417 46.60546875 413.53515625 C43.2489923 412.24660259 39.8922582 410.95874477 36.53466797 409.6730957 C30.917857 407.51938088 25.31822556 405.33861116 19.75 403.0625 C13.54183522 400.54603183 7.25699155 398.30636449 0.92822266 396.11401367 C-3.46871479 394.57818057 -7.71605482 392.87897073 -11.94140625 390.9140625 C-14.20032333 389.91105188 -16.48286256 389.07560341 -18.8125 388.25 C-24.26860809 386.3107345 -29.63073399 384.16502662 -35 382 C-43.46586116 378.59258841 -51.93829116 375.30647516 -60.625 372.5 C-63.51388244 371.55224383 -66.24441657 370.47027159 -69 369.1875 C-73.34681245 367.19299061 -77.79752151 365.62404547 -82.3125 364.0625 C-88.25388475 362.0068066 -94.0493323 359.76748295 -99.828125 357.28515625 C-104.44181193 355.41581758 -109.14313436 353.80966762 -113.86328125 352.23046875 C-118.17773296 350.75684198 -122.15499349 348.97110189 -126.20507812 346.88110352 C-128.37706451 345.814904 -130.53722138 345.11477915 -132.875 344.5 C-138.9868107 342.76707806 -144.76722708 340.39729793 -150.59375 337.87890625 C-157.85554379 334.76816593 -165.22530763 332.1135264 -172.70654297 329.58666992 C-178.28965193 327.68003987 -183.63608655 325.45090921 -189 323 C-194.34202833 320.72746801 -199.72867571 318.73244226 -205.25 316.9375 C-209.38962453 315.5875078 -213.12028906 313.98296337 -217 312 C-219.03840956 311.27167937 -221.09578727 310.61642465 -223.15625 309.953125 C-226.92466805 308.69008378 -230.64970382 307.32186113 -234.375 305.9375 C-235.42856689 305.5511438 -235.42856689 305.5511438 -236.50341797 305.15698242 C-239.60984198 303.99648488 -242.22743123 302.84837918 -245 301 C-246.40312138 300.53977619 -247.82270713 300.12866954 -249.25 299.75 C-264.53486766 295.30594156 -277.64663928 289.66154361 -286.25 275.5625 C-291.25661343 265.37046552 -292.98086546 255.42255332 -289.98046875 244.1796875 C-288.81373782 240.97205866 -287.70048257 237.9602767 -286 235 C-285.01 234.67 -284.02 234.34 -283 234 C-282.566875 232.824375 -282.566875 232.824375 -282.125 231.625 C-280.69251079 228.28252518 -279.17068395 227.66083445 -276 226 C-275.13181641 225.29230469 -275.13181641 225.29230469 -274.24609375 224.5703125 C-267.38580112 219.77407313 -257.94023887 217.82582249 -249.890625 215.7734375 C-246.53439394 214.87541892 -243.21575689 213.87441702 -239.89013672 212.86962891 C-236.74134416 211.92217164 -233.58800551 210.9910734 -230.43359375 210.0625 C-228.7155957 209.55589844 -228.7155957 209.55589844 -226.96289062 209.0390625 C-224.60903593 208.3452948 -222.25486784 207.65258956 -219.90039062 206.9609375 C-214.20114609 205.2784563 -208.52999714 203.55307283 -202.90258789 201.64355469 C-196.51554939 199.48312437 -190.03524438 197.58822839 -183.5625 195.703125 C-182.80582031 195.48253418 -182.04914063 195.26194336 -181.26953125 195.03466797 C-179.7884648 194.60417727 -178.30672077 194.17600895 -176.82421875 193.75048828 C-173.99684312 192.92983053 -171.22623554 192.09261517 -168.5 190.9765625 C-165.78268639 189.91511187 -163.03631739 189.25394198 -160.2074585 188.55856323 C-154.27491916 187.0574259 -148.42454448 185.23936421 -142.56494141 183.47900391 C-140.94355578 182.99456749 -139.32050016 182.51568437 -137.69580078 182.04248047 C-119.96585011 177.19211375 -119.96585011 177.19211375 -107.29296875 164.640625 C-102.69902619 155.25843415 -100.10561594 145.08834919 -97.29199219 135.06860352 C-95.70161947 129.41031475 -94.03690962 123.78677413 -92.25 118.1875 C-92.01434326 117.44902832 -91.77868652 116.71055664 -91.53588867 115.94970703 C-91.0068302 114.29324411 -90.47760285 112.63683512 -89.94824219 110.98046875 C-88.12852184 105.26081222 -86.33272703 99.53364779 -84.53894043 93.80581665 C-83.89495853 91.75117813 -83.24879101 89.69723597 -82.60253906 87.64331055 C-80.2482219 80.13836857 -78.00619857 72.60881472 -75.86669922 65.03930664 C-74.84669737 61.4624044 -73.75307181 57.9192256 -72.625 54.375 C-70.67450607 48.20343717 -68.79161449 42.01367073 -66.9375 35.8125 C-66.68186279 34.96244385 -66.42622559 34.1123877 -66.1628418 33.23657227 C-65.05469903 29.5488419 -63.9601544 25.85997119 -62.90625 22.15625 C-59.5354826 10.52166574 -54.89917332 0.91918169 -44.40625 -5.70703125 C-30.00332187 -13.44626698 -12.09384422 -9.76810494 0 0 Z "
        fill="#FFFFFF"
        transform="translate(331,38)"
      />
      <path
        d="M0 0 C2.89773963 1.37619923 5.81061831 2.34591442 8.86328125 3.3125 C15.14383913 5.39357639 21.30799663 7.83360122 27.4921875 10.18359375 C28.554375 10.58578125 29.6165625 10.98796875 30.7109375 11.40234375 C35.50723473 13.23185919 40.28724937 15.09481108 45.04296875 17.02734375 C54.48537445 20.8580972 63.94523943 24.5005128 73.60571289 27.74951172 C77.34654237 29.02030672 80.98244019 30.36325639 84.57421875 32.01171875 C89.26146457 34.1450523 94.06222434 35.93526462 98.88761902 37.72465515 C104.30558895 39.73447902 109.7035212 41.79195257 115.09375 43.875 C115.91300964 44.19117279 116.73226929 44.50734558 117.57635498 44.83309937 C120.93554368 46.12980734 124.29430653 47.42760775 127.65234375 48.72729492 C136.95646602 52.32689014 146.26290242 55.87674223 155.68359375 59.16210938 C158.13679524 60.05433773 160.49794406 61.02872022 162.8671875 62.12109375 C168.88744501 64.89197013 175.1359152 67.09366546 181.34863281 69.38818359 C183.49073984 70.18305657 185.62874157 70.98807295 187.765625 71.796875 C189.15361718 72.32169037 190.54163754 72.84643122 191.9296875 73.37109375 C192.60209473 73.62544189 193.27450195 73.87979004 193.96728516 74.1418457 C197.42931973 75.44215453 200.89679376 76.65433145 204.4296875 77.74609375 C213.44351299 80.74499006 219.95396442 85.38404242 225.4921875 93.18359375 C228.34904742 99.61152857 228.77448225 107.14260068 226.640625 113.8671875 C222.66180592 121.88585049 215.6133683 125.24920024 207.4921875 128.18359375 C206.33589844 128.34730469 205.17960938 128.51101563 203.98828125 128.6796875 C200.74802399 129.14671899 198.37520339 130.07366258 195.41072083 131.38587952 C192.25042394 132.69991132 188.97382263 133.62088324 185.6875 134.55859375 C184.96408417 134.76919434 184.24066833 134.97979492 183.49533081 135.19677734 C181.20380236 135.86322415 178.91062905 136.5237637 176.6171875 137.18359375 C173.59826 138.0561975 170.58009459 138.93139207 167.5625 139.80859375 C166.84410446 140.01721039 166.12570892 140.22582703 165.38554382 140.44076538 C160.37545346 141.90393273 155.4288233 143.49132953 150.4921875 145.18359375 C148.97454429 145.65238214 147.45432114 146.11306514 145.9296875 146.55859375 C144.69798828 146.92791016 144.69798828 146.92791016 143.44140625 147.3046875 C141.82364108 147.78680295 140.20530844 148.26708018 138.58447266 148.73876953 C136.46743965 149.35667387 134.35479821 149.98825183 132.2421875 150.62109375 C131.56857178 150.81429199 130.89495605 151.00749023 130.20092773 151.20654297 C124.74462933 152.85955782 120.06445141 154.76032292 116.8828125 159.6640625 C114.75846157 164.70575837 112.98046226 169.51315627 111.97827148 174.8984375 C111.36153109 177.7978298 110.38153139 180.54729393 109.42871094 183.35058594 C107.38739901 189.52560774 105.55755063 195.76977591 103.6796875 201.99609375 C103.23171739 203.47749075 102.78363717 204.95885444 102.33544922 206.44018555 C100.16050365 213.63288045 97.99672536 220.8287556 95.8527832 228.03076172 C94.93772635 231.09755365 94.01245334 234.16117404 93.08300781 237.22363281 C92.52978062 239.058884 91.99092203 240.8984493 91.453125 242.73828125 C89.0265612 250.64927381 86.15947056 258.58657227 78.4921875 262.68359375 C72.18656595 265.29404955 66.12876962 265.82586661 59.4921875 264.18359375 C51.44048363 260.46076293 46.32009885 254.87598089 42.9921875 246.68359375 C42.69449463 245.97654297 42.39680176 245.26949219 42.09008789 244.54101562 C39.41715863 238.14268671 36.91429673 231.68063518 34.4921875 225.18359375 C34.0159968 223.91652688 33.53941792 222.64960583 33.0625 221.3828125 C31.79045794 218.00066736 30.52363203 214.61659425 29.25830078 211.23193359 C28.50263761 209.21153397 27.74574052 207.19160189 26.98828125 205.171875 C26.74110352 204.51276123 26.49392578 203.85364746 26.23925781 203.17456055 C25.7428706 201.85167241 25.24612817 200.52891751 24.74902344 199.20629883 C23.45143741 195.75187993 22.16258214 192.29453771 20.88671875 188.83203125 C20.62181641 188.11660156 20.35691406 187.40117187 20.08398438 186.6640625 C19.58121701 185.30570858 19.08102382 183.94639778 18.58398438 182.5859375 C17.49250704 179.64475769 16.31815842 176.8368247 14.91015625 174.03125 C13.61358505 171.42739214 12.75371894 169.04290863 11.9921875 166.24609375 C11.05100327 162.80068718 9.84061987 159.60734471 8.40673828 156.3371582 C6.3643908 151.52788241 4.54761353 146.6250575 2.6796875 141.74609375 C2.23608887 140.59044922 1.79249023 139.43480469 1.33544922 138.24414062 C-1.53372891 130.75896428 -4.37154481 123.26308936 -7.15625 115.74609375 C-8.18631547 113.03100787 -9.24563756 110.33698198 -10.33203125 107.64453125 C-13.22279373 100.45161803 -15.92635986 93.18687674 -18.65063477 85.9296875 C-21.44186843 78.4993246 -24.32819761 71.12903966 -27.41137695 63.81494141 C-28.82415907 60.42439016 -30.11366054 57.00558042 -31.3828125 53.55859375 C-32.99954454 49.1780658 -34.64384043 44.81335742 -36.375 40.4765625 C-36.68840332 39.68781738 -37.00180664 38.89907227 -37.32470703 38.08642578 C-37.92689921 36.576061 -38.53427652 35.06774842 -39.14794922 33.56201172 C-43.0397552 23.76834611 -44.49577662 15.69969837 -41.3828125 5.49609375 C-38.16453277 -0.18953378 -34.0437477 -3.5217808 -27.9453125 -5.87890625 C-18.31896344 -8.35132721 -8.57031812 -4.18579305 0 0 Z "
        fill="#FFFFFF"
        transform="translate(453.5078125,132.81640625)"
      />
      <path
        d="M0 0 C0.82081055 0.3105835 1.64162109 0.62116699 2.48730469 0.94116211 C5.03704665 1.90939076 7.58140561 2.89074812 10.125 3.875 C11.69529897 4.47789983 13.26561107 5.08076545 14.8359375 5.68359375 C21.97774516 8.43719042 29.09012558 11.25909818 36.1875 14.125 C40.74977847 15.96062325 45.29737832 17.69654086 50 19.13671875 C52.47852313 19.99782329 54.86290563 21.04292024 57.26855469 22.08764648 C60.22676226 23.34227818 63.2372466 24.44631005 66.25 25.5625 C72.82563652 28.0078222 79.38453575 30.49457461 85.9375 33 C91.17295714 35.00115135 96.40586811 36.9981937 101.6875 38.875 C111.5859388 42.43151378 121.31660626 46.49044979 131.046875 50.48046875 C138.94673456 53.69733296 146.90572161 56.60978869 154.98632812 59.34008789 C159.83799461 60.99741323 164.49974946 62.87947079 169.16503906 65.00488281 C171.34288804 65.97173056 173.53256601 66.74700571 175.8125 67.4375 C178.41822053 68.268635 180.60906945 69.1221844 183.0625 70.375 C186.53031045 72.07351941 189.98212794 73.06425215 193.68359375 74.12890625 C196.95208794 75.12775807 200.00570636 76.48245819 203.125 77.875 C204.72644907 78.52754292 206.33086069 79.17284267 207.9375 79.8125 C208.78570312 80.15539062 209.63390625 80.49828125 210.5078125 80.8515625 C212.23884902 81.52847529 213.98420503 82.16995098 215.7421875 82.7734375 C222.85799318 85.30398238 227.74324478 88.54260846 231.44140625 95.26953125 C235.17649539 103.74180662 234.86952647 109.69231293 231.78125 118.28515625 C226.50878017 126.52960789 219.31011214 129.33842082 210.1875 131.8125 C207.85626663 132.48523441 205.52554928 133.15975917 203.1953125 133.8359375 C202.01614258 134.17206055 200.83697266 134.50818359 199.62207031 134.85449219 C194.2291988 136.42822878 188.90022023 138.1876152 183.5625 139.9375 C175.13625092 142.67172234 166.66885619 145.16054131 158.125 147.5 C150.82252784 149.51375154 143.55150593 151.57032164 136.375 154 C135.70210937 154.21736816 135.02921875 154.43473633 134.3359375 154.65869141 C129.86673401 156.22917137 127.21479781 158.32065217 124.125 161.875 C123.56296875 162.50792969 123.0009375 163.14085937 122.421875 163.79296875 C120.72740951 166.5133004 120.12352446 169.06982499 119.375 172.1875 C117.66516487 179.0251099 115.69313221 185.76245571 113.625 192.5 C113.31868652 193.4988623 113.01237305 194.49772461 112.69677734 195.52685547 C111.84140387 198.31015517 110.98332383 201.0926091 110.125 203.875 C109.74085938 205.12925781 109.35671875 206.38351562 108.9609375 207.67578125 C107.63835431 211.99299386 106.30395261 216.30603771 104.94921875 220.61328125 C104.74312988 221.26868896 104.53704102 221.92409668 104.32470703 222.59936523 C103.90083403 223.94682664 103.47603325 225.29399655 103.05029297 226.64086914 C101.93686607 230.18710409 100.87044903 233.74013588 99.87109375 237.3203125 C93.67978189 259.4460038 93.67978189 259.4460038 85.125 264.875 C79.00888421 267.82322217 73.7276533 268.45915308 67.125 266.875 C59.25324144 264.1198845 54.81152821 260.34142102 50.7109375 253.19140625 C48.39607999 248.35073131 46.7236221 243.34215368 45.01879883 238.26025391 C41.52797823 227.90646292 37.38418041 217.82219917 33.27294922 207.70263672 C32.155213 204.94942089 31.04163758 202.19463066 29.93359375 199.4375 C29.62607178 198.67308594 29.3185498 197.90867187 29.00170898 197.12109375 C28.08092842 194.76209035 27.22089077 192.38679046 26.375 190 C24.46213879 184.6756186 22.36425111 179.43412126 20.25 174.1875 C16.99212838 166.09624102 13.86129587 157.96853577 10.83398438 149.78857422 C9.64715635 146.58528289 8.44889539 143.38629074 7.25 140.1875 C7.00894531 139.54369385 6.76789063 138.8998877 6.51953125 138.23657227 C4.02560984 131.5874612 1.48790407 124.95511503 -1.04760742 118.32177734 C-2.76034613 113.83250762 -4.44718665 109.33799328 -6.0625 104.8125 C-7.76481853 100.07300523 -9.68869844 95.44061846 -11.64453125 90.80078125 C-12.80484557 88.04181164 -13.94303561 85.27577229 -15.0625 82.5 C-15.36542969 81.74976563 -15.66835937 80.99953125 -15.98046875 80.2265625 C-16.60068513 78.59612467 -17.17600832 76.94817439 -17.71484375 75.2890625 C-19.39755373 70.33724929 -21.33388084 65.49043982 -23.25 60.625 C-23.63671875 59.63886719 -24.0234375 58.65273438 -24.421875 57.63671875 C-26.27933435 52.90580717 -28.15409154 48.18324591 -30.0625 43.47265625 C-31.37298789 40.20327896 -32.55247612 36.95874522 -33.5 33.5625 C-34.19610627 31.08518063 -34.91628511 28.77937641 -35.9375 26.4140625 C-38.04347086 20.71039143 -37.79930427 14.11244944 -35.3125 8.5625 C-31.53504598 2.11705398 -26.33248167 -1.36272458 -19.37890625 -3.77734375 C-12.47926528 -4.73532822 -6.32473687 -2.45292214 0 0 Z "
        fill="#FFFFFF"
        transform="translate(175.875,403.125)"
      />
      <path
        d="M0 0 C16.83 0 33.66 0 51 0 C54.39455575 9.14644188 57.76367976 18.29908476 61.08435059 27.47216797 C61.70811936 29.19420553 62.33291673 30.91587076 62.95861816 32.63720703 C73.0285203 60.35152921 82.33599922 88.00562919 88 117 C88.5245258 115.08434054 89.04412596 113.16733326 89.5625 111.25 C89.74538574 110.5799292 89.92827148 109.9098584 90.11669922 109.21948242 C91.2436669 105.03038257 92.26946938 100.83678001 93.19140625 96.59765625 C100.59949117 63.57282907 113.46259588 31.72786134 125 0 C142.16 0 159.32 0 177 0 C177 53.13 177 106.26 177 161 C165.78 161 154.56 161 143 161 C143 120.74 143 80.48 143 39 C139.04 52.86 135.08 66.72 131 81 C127.85784501 90.56361282 124.6747119 100.07932007 121.3125 109.5625 C120.52693052 111.80887289 119.74243109 114.05562027 118.95898438 116.30273438 C113.73928899 131.23766339 108.37432191 146.12014763 103 161 C93.43 161 83.86 161 74 161 C69.49873456 150.87215276 69.49873456 150.87215276 67.65332031 145.68359375 C67.23898743 144.5236792 66.82465454 143.36376465 66.39776611 142.16870117 C65.96228455 140.93740479 65.52680298 139.7061084 65.078125 138.4375 C64.60996013 137.12012798 64.14159214 135.80282813 63.67303467 134.4855957 C62.69243783 131.72624868 61.71443896 128.96599854 60.73828125 126.20507812 C59.75661488 123.42913215 58.77167529 120.65438918 57.78320312 117.88085938 C48.60697097 92.13335977 40.38361744 66.37006229 33 40 C33 79.93 33 119.86 33 161 C22.11 161 11.22 161 0 161 C0 107.87 0 54.74 0 0 Z "
        fill="#FFFFFF"
        transform="translate(825,355)"
      />
      <path
        d="M0 0 C16.83 0 33.66 0 51 0 C57.41740949 17.68352838 57.41740949 17.68352838 60.20703125 25.453125 C62.08275762 30.67709047 63.96122544 35.89989978 65.86083984 41.11523438 C73.89040695 63.17474612 80.89766133 85.07199797 86 108 C86.31807617 109.41949951 86.31807617 109.41949951 86.64257812 110.86767578 C87.09867599 112.91097831 87.55004173 114.95533669 88 117 C88.5245258 115.08434054 89.04412596 113.16733326 89.5625 111.25 C89.74466064 110.58210449 89.92682129 109.91420898 90.11450195 109.22607422 C91.25090355 104.999572 92.28691866 100.76690526 93.2265625 96.4921875 C98.75656058 72.01830144 107.56350066 48.58915381 116 25 C116.55277977 23.44961847 117.10536869 21.89916887 117.65771484 20.34863281 C120.07946096 13.55606813 122.53189601 6.77606732 125 0 C142.16 0 159.32 0 177 0 C177 53.13 177 106.26 177 161 C165.78 161 154.56 161 143 161 C143 120.74 143 80.48 143 39 C139.37 51.87 135.74 64.74 132 78 C129.82408099 84.81269881 127.62984014 91.57573444 125.25 98.3125 C124.67418053 99.97034863 124.09917607 101.62848052 123.52490234 103.28686523 C121.70293533 108.53157944 119.85461708 113.76675542 118 119 C117.66045288 119.95898193 117.32090576 120.91796387 116.97106934 121.90600586 C112.35014646 134.95036944 107.68811539 147.9796459 103 161 C93.43 161 83.86 161 74 161 C69.49873456 150.87215276 69.49873456 150.87215276 67.65332031 145.68359375 C67.23898743 144.5236792 66.82465454 143.36376465 66.39776611 142.16870117 C65.96228455 140.93740479 65.52680298 139.7061084 65.078125 138.4375 C64.60996013 137.12012798 64.14159214 135.80282813 63.67303467 134.4855957 C62.69243783 131.72624868 61.71443896 128.96599854 60.73828125 126.20507812 C59.75661488 123.42913215 58.77167529 120.65438918 57.78320312 117.88085938 C48.60697097 92.13335977 40.38361744 66.37006229 33 40 C33 79.93 33 119.86 33 161 C22.11 161 11.22 161 0 161 C0 107.87 0 54.74 0 0 Z "
        fill="#FFFFFF"
        transform="translate(825,135)"
      />
      <path
        d="M0 0 C14.52 0 29.04 0 44 0 C51.89797756 22.00698601 59.73687391 44.02681701 67.375 66.125 C74.22734799 85.94929613 81.18726106 105.73351548 88.21072388 125.49780273 C89.48958292 129.09793581 90.76653036 132.69874397 92.04260254 136.29986572 C92.70082958 138.15625398 93.35997931 140.01231526 94.01989746 141.86810303 C95.01374673 144.66489302 96.0034465 147.46311941 96.9921875 150.26171875 C97.29577179 151.11353226 97.59935608 151.96534576 97.91213989 152.8429718 C100 158.77174991 100 158.77174991 100 161 C87.46 161 74.92 161 62 161 C56.06 143.18 56.06 143.18 50 125 C31.52 124.67 13.04 124.34 -6 124 C-6.66 126.97 -7.32 129.94 -8 133 C-8.68752505 135.3448206 -9.40757746 137.68041647 -10.1640625 140.00390625 C-10.5245166 141.11838135 -10.8849707 142.23285645 -11.25634766 143.38110352 C-11.70800293 144.76096436 -12.1596582 146.1408252 -12.625 147.5625 C-14.06875 151.996875 -15.5125 156.43125 -17 161 C-29.54 161 -42.08 161 -55 161 C-40.34537298 116.83258246 -25.6060493 72.67928917 -10.25 28.75 C-9.79963882 27.46160721 -9.79963882 27.46160721 -9.34017944 26.14718628 C-8.50436978 23.75903785 -7.66690294 21.37148238 -6.828125 18.984375 C-6.59690445 18.32613235 -6.3656839 17.66788971 -6.12745667 16.98970032 C-4.12480303 11.31120605 -2.05805747 5.65965804 0 0 Z M21 30 C20.73896484 31.04003174 20.47792969 32.08006348 20.20898438 33.15161133 C15.57015789 51.59885719 10.90693435 70.00796775 5.33789062 88.20043945 C4.87286133 89.71963989 4.87286133 89.71963989 4.3984375 91.26953125 C4.12692871 92.14198486 3.85541992 93.01443848 3.57568359 93.91333008 C2.91134977 95.96055798 2.91134977 95.96055798 3 98 C15.54 98 28.08 98 41 98 C39.74484722 92.35181248 38.48389959 86.99630504 36.828125 81.4921875 C36.40942048 80.08921799 35.99080403 78.6862222 35.57226562 77.28320312 C35.35610596 76.56269775 35.13994629 75.84219238 34.91723633 75.09985352 C31.28957389 63.00366334 27.78643365 50.90315825 24.80175781 38.62841797 C24.58874023 37.77135254 24.37572266 36.91428711 24.15625 36.03125 C23.97900391 35.29455078 23.80175781 34.55785156 23.61914062 33.79882812 C23.07077984 31.77845928 23.07077984 31.77845928 21 30 Z "
        fill="#FFFFFF"
        transform="translate(1075,135)"
      />
      <path
        d="M0 0 C10.89 0 21.78 0 33 0 C33 53.13 33 106.26 33 161 C22.11 161 11.22 161 0 161 C-0.33 155.39 -0.66 149.78 -1 144 C-2.32 145.98 -3.64 147.96 -5 150 C-10.59772809 156.39740353 -18.39974486 162.36309958 -27.09741211 163.20239258 C-29.48589307 163.30486866 -31.8593914 163.32901136 -34.25 163.3125 C-35.0968335 163.30686035 -35.94366699 163.3012207 -36.81616211 163.29541016 C-49.18062191 163.05527739 -59.05945391 158.83471131 -68.1875 150.375 C-83.82016761 133.73173569 -84.63949755 112.61251765 -84.140625 91.05810547 C-83.86842854 85.13877754 -82.81152504 79.65320744 -81 74 C-80.7215625 73.10796875 -80.443125 72.2159375 -80.15625 71.296875 C-76.04575081 59.74495486 -67.82581264 49.088548 -56.8671875 43.36328125 C-45.24356054 38.37968689 -31.3461608 36.58963354 -19.171875 40.9609375 C-11.32493068 44.71505115 -5.76038247 50.85942629 -1 58 C-0.67 38.86 -0.34 19.72 0 0 Z M-42.25 73.125 C-50.54619282 83.61391953 -51.05681086 97.20847114 -50 110 C-48.01272912 120.1731794 -44.40754827 127.82302576 -36 134 C-29.95873101 136.89899821 -23.10236652 137.13992547 -16.65234375 135.34765625 C-8.99818767 131.91139735 -4.96850124 125.7069607 -1.76171875 118.2109375 C1.94671605 107.44696777 1.94416394 91.30363766 -3 81 C-6.62107146 73.79637912 -11.15323685 68.61176934 -19 66 C-28.39631819 64.88540226 -35.63638616 66.16589887 -42.25 73.125 Z "
        fill="#FFFFFF"
        transform="translate(1239,355)"
      />
      <path
        d="M0 0 C89.32221578 0 89.32221578 0 106.875 16.375 C118.98492311 29.35198205 120.61584084 45.65195839 120.13183594 62.49951172 C119.46466221 75.15357348 113.40359488 87.4971326 104 96 C91.68947698 105.2423619 78.57843938 109.38804777 63.2734375 109.1953125 C62.49718018 109.19329834 61.72092285 109.19128418 60.92114258 109.18920898 C58.07236667 109.17889036 55.22367622 109.15097018 52.375 109.125 C42.784375 109.063125 42.784375 109.063125 33 109 C33 126.16 33 143.32 33 161 C22.11 161 11.22 161 0 161 C0 107.87 0 54.74 0 0 Z M33 29 C33 46.49 33 63.98 33 82 C57.50736538 83.68242637 57.50736538 83.68242637 79 74 C85.48612254 65.93113942 85.6240669 58.12123052 85 48 C83.86786772 42.33042416 81.11813968 38.02662546 77 34 C70.54974638 29.97822832 65.19926986 28.87222512 57.609375 28.90234375 C56.31999023 28.90484131 55.03060547 28.90733887 53.70214844 28.90991211 C52.06793945 28.91901611 50.43373047 28.92812012 48.75 28.9375 C43.5525 28.958125 38.355 28.97875 33 29 Z "
        fill="#FFFFFF"
        transform="translate(1194,135)"
      />
      <path
        d="M0 0 C13.12148426 11.09668639 18.4632514 25.28800512 20.26953125 41.99609375 C20.26953125 47.93609375 20.26953125 53.87609375 20.26953125 59.99609375 C-6.79046875 59.99609375 -33.85046875 59.99609375 -61.73046875 59.99609375 C-58.60045884 74.57778413 -58.60045884 74.57778413 -48.73046875 83.99609375 C-41.978093 88.16245326 -34.45778168 87.7411976 -26.73046875 86.99609375 C-19.38402754 85.02292214 -15.81656327 80.12523554 -11.73046875 73.99609375 C-2.16046875 75.64609375 7.40953125 77.29609375 17.26953125 78.99609375 C18.57499897 82.91249692 17.67959547 83.96596226 15.89453125 87.62109375 C10.20911633 98.46792222 1.39886313 106.07739232 -10.125 110.21484375 C-16.95861357 112.28787929 -23.59372872 113.7145414 -30.73046875 113.99609375 C-31.78041016 114.05603516 -31.78041016 114.05603516 -32.8515625 114.1171875 C-49.54127247 114.63778396 -65.73112052 110.08211569 -78.2109375 98.7421875 C-91.43639985 84.94074187 -95.33711589 67.56418988 -95.13720703 49.01708984 C-94.91190516 41.38748869 -93.96162724 34.32704307 -91.73046875 26.99609375 C-91.46363281 26.11050781 -91.19679688 25.22492188 -90.921875 24.3125 C-86.41381308 11.46953248 -76.83340034 1.02191981 -64.91796875 -5.31640625 C-44.09799236 -14.9035221 -18.76356852 -13.77068763 0 0 Z M-57.91796875 25.68359375 C-60.42291043 29.87004861 -60.42291043 29.87004861 -61.73046875 38.99609375 C-45.23046875 38.99609375 -28.73046875 38.99609375 -11.73046875 38.99609375 C-14.90552294 25.43878208 -14.90552294 25.43878208 -24.35546875 16.55859375 C-37.63899063 10.4088151 -49.03884314 14.77495371 -57.91796875 25.68359375 Z "
        fill="#FFFFFF"
        transform="translate(1773.73046875,405.00390625)"
      />
      <path
        d="M0 0 C13.76308513 11.54699515 18.80508914 26.69911979 20.4921875 44.18359375 C20.4921875 49.46359375 20.4921875 54.74359375 20.4921875 60.18359375 C-6.5678125 60.18359375 -33.6278125 60.18359375 -61.5078125 60.18359375 C-59.45555977 71.1236126 -59.45555977 71.1236126 -54.5078125 79.18359375 C-54.5078125 79.84359375 -54.5078125 80.50359375 -54.5078125 81.18359375 C-53.6725 81.58578125 -53.6725 81.58578125 -52.8203125 81.99609375 C-50.5078125 83.18359375 -50.5078125 83.18359375 -48.0078125 84.74609375 C-41.27945644 88.61489848 -31.30927106 88.4528615 -23.921875 86.5 C-18.10398907 83.81396454 -15.00626699 79.43127548 -11.5078125 74.18359375 C-1.9378125 75.83359375 7.6321875 77.48359375 17.4921875 79.18359375 C18.79765522 83.09999692 17.90225172 84.15346226 16.1171875 87.80859375 C10.28392192 98.93749675 1.01767259 106.49452623 -10.6953125 110.93359375 C-29.10902717 116.46097879 -50.18178545 115.65544374 -67.31640625 106.71875 C-81.04210422 98.62801264 -89.47424275 86.05779989 -93.4453125 70.74609375 C-96.98232265 51.09358112 -95.65376761 29.2616996 -84.5078125 12.18359375 C-75.55317921 0.44242952 -64.48822627 -7.31461396 -49.8515625 -10.37109375 C-32.15369164 -12.72805319 -14.76067707 -10.69114461 0 0 Z M-55.5078125 22.18359375 C-59.08022399 27.97861353 -60.52536814 32.30648326 -61.5078125 39.18359375 C-45.0078125 39.18359375 -28.5078125 39.18359375 -11.5078125 39.18359375 C-14.68286669 25.62628208 -14.68286669 25.62628208 -24.1328125 16.74609375 C-34.83378543 11.79193962 -47.20658291 13.42118473 -55.5078125 22.18359375 Z "
        fill="#FFFFFF"
        transform="translate(1118.5078125,404.81640625)"
      />
      <path
        d="M0 0 C0.57492187 0.41121094 1.14984375 0.82242187 1.7421875 1.24609375 C2.6290625 1.86484375 3.5159375 2.48359375 4.4296875 3.12109375 C11.47577264 9.59587469 14.71532003 18.03777358 16.7421875 27.24609375 C16.83194474 30.09869079 16.86839654 32.92609859 16.85571289 35.77832031 C16.85585892 36.63721863 16.85600494 37.49611694 16.8561554 38.38104248 C16.85545946 41.21629371 16.84768195 44.05147901 16.83984375 46.88671875 C16.83797844 48.8539832 16.83655507 50.82124811 16.83555603 52.78851318 C16.83173977 57.96375819 16.82191706 63.13897508 16.81085205 68.31420898 C16.8006188 73.59618754 16.7960543 78.87817064 16.79101562 84.16015625 C16.78029401 94.52214975 16.76270439 104.88411501 16.7421875 115.24609375 C5.8521875 115.24609375 -5.0378125 115.24609375 -16.2578125 115.24609375 C-16.27239502 112.95542969 -16.28697754 110.66476562 -16.30200195 108.3046875 C-16.35244999 100.71696784 -16.41906292 93.1294512 -16.49352741 85.54193115 C-16.53816114 80.94382497 -16.57743253 76.34580595 -16.60424805 71.74755859 C-16.63035105 67.30589915 -16.67080249 62.86457642 -16.72099876 58.42312622 C-16.7376203 56.73280033 -16.74916383 55.04241627 -16.75542641 53.35202026 C-16.76511918 50.97521067 -16.79323835 48.59925341 -16.82543945 46.22265625 C-16.82400436 45.53141159 -16.82256927 44.84016693 -16.8210907 44.12797546 C-16.94326485 37.70765037 -18.49922281 32.38491904 -22.5703125 27.43359375 C-28.38350052 22.70192908 -32.87528946 21.68725171 -40.28515625 21.8984375 C-46.18465993 22.5883926 -49.78657566 24.87293937 -54.0703125 28.87109375 C-60.49427439 37.61818467 -59.72886383 48.86966051 -59.76953125 59.19140625 C-59.78640583 60.81380548 -59.80455974 62.43619186 -59.82392883 64.05856323 C-59.8711337 68.29658998 -59.90113287 72.53456461 -59.92736816 76.77276611 C-59.96260502 81.87503933 -60.01953253 86.97711249 -60.07276154 92.07922363 C-60.15092883 99.80148709 -60.20179565 107.52349494 -60.2578125 115.24609375 C-71.1478125 115.24609375 -82.0378125 115.24609375 -93.2578125 115.24609375 C-93.2578125 75.31609375 -93.2578125 35.38609375 -93.2578125 -5.75390625 C-83.0278125 -5.75390625 -72.7978125 -5.75390625 -62.2578125 -5.75390625 C-61.5978125 0.51609375 -60.9378125 6.78609375 -60.2578125 13.24609375 C-59.2471875 11.88484375 -58.2365625 10.52359375 -57.1953125 9.12109375 C-43.3927975 -8.49854965 -18.87576822 -12.77336123 0 0 Z "
        fill="#FFFFFF"
        transform="translate(1640.2578125,400.75390625)"
      />
      <path
        d="M0 0 C8.86544547 7.45469619 13.60155576 15.96169236 16.45703125 27.1484375 C16.45703125 28.1384375 16.45703125 29.1284375 16.45703125 30.1484375 C12.22934687 30.98941164 7.99966469 31.81987775 3.76953125 32.6484375 C2.57134766 32.88691406 1.37316406 33.12539063 0.13867188 33.37109375 C-1.01826172 33.59667969 -2.17519531 33.82226562 -3.3671875 34.0546875 C-4.43026123 34.26416016 -5.49333496 34.47363281 -6.58862305 34.68945312 C-9.30177298 35.11096555 -11.80409534 35.23700253 -14.54296875 35.1484375 C-14.90648437 34.34019531 -15.27 33.53195312 -15.64453125 32.69921875 C-19.19641827 25.14918199 -21.68146242 20.3205999 -29.48046875 16.8359375 C-37.13023429 15.1186432 -43.74944426 16.41612854 -50.49609375 20.26171875 C-56.76208934 24.87948507 -59.23719596 32.16654004 -61.15625 39.48828125 C-63.21479327 53.64856372 -61.9474397 68.52926537 -53.22265625 80.3359375 C-49.53764376 84.31232307 -45.9713489 85.87035402 -40.609375 86.484375 C-32.96387744 86.73254346 -27.93034159 85.82682533 -21.85546875 81.0234375 C-18.26118932 76.55487388 -16.34472946 71.55371964 -14.54296875 66.1484375 C-10.44884719 66.83813776 -6.35545473 67.53199714 -2.26269531 68.22973633 C-0.86998645 68.46656176 0.52291709 68.70224525 1.91601562 68.93676758 C3.9171887 69.27385977 5.9176281 69.61503854 7.91796875 69.95703125 C9.12243652 70.16126709 10.3269043 70.36550293 11.56787109 70.57592773 C14.45703125 71.1484375 14.45703125 71.1484375 16.45703125 72.1484375 C15.99071171 84.27274546 9.11535888 94.08077781 0.45703125 102.1484375 C-12.73709027 113.0612225 -29.85196745 115.16016397 -46.41796875 113.69140625 C-52.3986951 113.00634628 -57.94510906 111.32799631 -63.54296875 109.1484375 C-64.27773437 108.87257813 -65.0125 108.59671875 -65.76953125 108.3125 C-77.04469599 103.41611372 -86.36102696 92.49560845 -91.29296875 81.4609375 C-98.76383913 61.85914887 -99.19815052 40.01052877 -91.03515625 20.5546875 C-83.67964156 5.91208151 -72.91641236 -3.38758231 -57.54296875 -8.7890625 C-38.60485072 -14.55449763 -16.01407496 -11.66001772 0 0 Z "
        fill="#FFFFFF"
        transform="translate(1449.54296875,404.8515625)"
      />
      <path
        d="M0 0 C11.22 0 22.44 0 34 0 C34 39.93 34 79.86 34 121 C22.78 121 11.56 121 0 121 C0 81.07 0 41.14 0 0 Z "
        fill="#FFFFFF"
        transform="translate(1487,395)"
      />
      <path
        d="M0 0 C11.22 0 22.44 0 34 0 C34 39.93 34 79.86 34 121 C22.78 121 11.56 121 0 121 C0 81.07 0 41.14 0 0 Z "
        fill="#FFFFFF"
        transform="translate(1298,395)"
      />
      <path
        d="M0 0 C4.01684726 2.93915653 6.95784056 6.06102168 8.5625 10.875 C9.08416057 15.84360315 9.1349051 19.73018979 6.875 24.25 C2.57012054 29.13661992 -0.93513793 31.68290029 -7.4375 32.875 C-13.50551605 32.97030915 -17.68889901 31.85057292 -22.4375 27.875 C-26.77206803 23.07183002 -27.75071307 19.46274667 -27.6484375 13.15234375 C-27.19710138 8.27958531 -25.0184493 5.18914976 -21.4375 2.0625 C-15.26967411 -2.43487304 -7.1179857 -2.32952259 0 0 Z "
        fill="#FFFFFF"
        transform="translate(1513.4375,348.125)"
      />
      <path
        d="M0 0 C4.01684726 2.93915653 6.95784056 6.06102168 8.5625 10.875 C9.08416057 15.84360315 9.1349051 19.73018979 6.875 24.25 C2.57012054 29.13661992 -0.93513793 31.68290029 -7.4375 32.875 C-13.50551605 32.97030915 -17.68889901 31.85057292 -22.4375 27.875 C-26.77206803 23.07183002 -27.75071307 19.46274667 -27.6484375 13.15234375 C-27.19710138 8.27958531 -25.0184493 5.18914976 -21.4375 2.0625 C-15.26967411 -2.43487304 -7.1179857 -2.32952259 0 0 Z "
        fill="#FFFFFF"
        transform="translate(1324.4375,348.125)"
      />
    </svg>
  ),
  GearSettings: (props: IconProps) => (
    <svg
      width="28px"
      height="28px"
      viewBox="0 0 28 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Production"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-211, -235)"
        >
          <g
            id="icon-settings"
            transform="translate(211, 235)"
          >
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="28"
              height="28"
            ></rect>
            <path
              d="M20.2015688,10.2525279 C20.0232123,10.6274217 20.0120959,11.0603422 20.1709774,11.4438954 C20.3298588,11.8274487 20.6438515,12.1256974 21.0350638,12.2646554 L22.0250838,12.6168364 C22.6105106,12.8246232 23.00167,13.3785255 23.00167,13.9997339 C23.00167,14.6209423 22.6105106,15.1748446 22.0250838,15.3826314 L21.0350638,15.7348124 C20.6438515,15.8737704 20.3298588,16.1720191 20.1709774,16.5555724 C20.0120959,16.9391256 20.0232123,17.3720461 20.2015688,17.7469399 L20.6539257,18.6946982 C20.9219287,19.2558525 20.8071211,19.9250005 20.367394,20.3647276 C19.9276669,20.8044547 19.2585189,20.9192624 18.6973645,20.6512594 L17.748041,20.2004677 C17.3731472,20.0221111 16.9402267,20.0109948 16.5566735,20.1698763 C16.1731202,20.3287577 15.8748715,20.6427504 15.7359135,21.0339627 L15.3837325,22.0239827 C15.1756233,22.6088399 14.6220059,22.9994678 14.0012263,22.9994678 C13.3804467,22.9994678 12.8268293,22.6088399 12.6187202,22.0239827 L12.2665391,21.0339627 C12.127404,20.6426994 11.8290064,20.3287067 11.4453321,20.1698369 C11.0616578,20.0109671 10.6286351,20.0220972 10.253629,20.2004677 L9.30587073,20.6512594 C8.7446872,20.9203194 8.07479926,20.8059063 7.63473092,20.365838 C7.19466259,19.9257696 7.08024945,19.2558817 7.34930952,18.6946982 L7.80010123,17.7453747 C7.97845774,17.3704809 7.98957409,16.9375604 7.83069263,16.5540071 C7.67181118,16.1704539 7.35781846,15.8722052 6.96660615,15.7332471 L5.97658618,15.3810661 C5.39115942,15.1732793 5,14.619377 5,13.9981686 C5,13.3769603 5.39115942,12.8230579 5.97658618,12.6152712 L6.96660615,12.2630902 C7.35740035,12.124078 7.67105878,11.8260915 7.82990186,11.4429292 C7.98874494,11.0597669 7.97791757,10.6272622 7.80010123,10.2525279 L7.34930952,9.30320437 C7.08024945,8.74202085 7.19466259,8.0721329 7.63473092,7.63206456 C8.07479926,7.19199623 8.7446872,7.07758309 9.30587073,7.34664317 L10.2551942,7.79743487 C10.6298363,7.97533367 11.0622628,7.98639209 11.445508,7.82787471 C11.8287532,7.66935733 12.1270239,7.35606892 12.2665391,6.96550504 L12.6187202,5.97548507 C12.8268293,5.39062793 13.3804467,5 14.0012263,5 C14.6220059,5 15.1756233,5.39062793 15.3837325,5.97548507 L15.7359135,6.96550504 C15.8748715,7.35671735 16.1731202,7.67071008 16.5566735,7.82959153 C16.9402267,7.98847298 17.3731472,7.97735664 17.748041,7.79900012 L18.6973645,7.34664317 C19.2585189,7.07864018 19.9276669,7.19344783 20.367394,7.63317492 C20.8071211,8.07290202 20.9219287,8.74204999 20.6539257,9.30320437 L20.2015688,10.2525279 Z"
              id="Path"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <circle
              id="Oval"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              cx="14.000835"
              cy="13.9997339"
              r="3.52181017"
            ></circle>
          </g>
        </g>
      </g>
    </svg>
  ),

  // Aliases
  'tab-segmentation': (props: IconProps) => Icons.TabSegmentation(props),
  'tab-studies': (props: IconProps) => Icons.TabStudies(props),
  'tab-linear': (props: IconProps) => Icons.TabLinear(props),
  'tab-4d': (props: IconProps) => Icons.Tab4D(props),
  'tab-patient-info': (props: IconProps) => Icons.TabPatientInfo(props),
  'tab-roi-threshold': (props: IconProps) => Icons.TabRoiThreshold(props),
  'icon-mpr': (props: IconProps) => Icons.IconMPR(props),
  'power-off': (props: IconProps) => Icons.PowerOff(props),
  'icon-multiple-patients': (props: IconProps) => Icons.MultiplePatients(props),
  'icon-patient': (props: IconProps) => Icons.Patient(props),
  'icon-chevron-patient': (props: IconProps) => Icons.ChevronPatient(props),
  info: (props: IconProps) => Icons.Info(props),
  settings: (props: IconProps) => Icons.Settings(props),
};
